import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

export const ProcessErrors = ({ errorMessages }) => {
  if (!Array.isArray(errorMessages) || errorMessages.length === 0) {
    return null;
  }
  return (
    <Results>
      <ErrorList>
        {errorMessages.map((item, index) => (
          <ErrorListItem key={`error-${index}`}>
            <strong>Error:</strong> {item.error_message}
          </ErrorListItem>
        ))}
      </ErrorList>
    </Results>
  );
};

ProcessErrors.propTypes = {
  errorMessages: PropTypes.object.isRequired,
};

ProcessErrors.defaultProps = {
  errorMessages: [],
};

const Results = styled.div`
  margin: 0 0 0 22px;
`;

const ErrorList = styled.ul`
  margin: 0;
  padding: 0;
`;

const ErrorListItem = styled.li`
  margin-bottom: 12px;
`;

export default ProcessErrors;
